<template lang="pug">
b-form-input(
  :value="value"
  :size="size"
  :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
  @input="handleInput"
  @blur.native="handleBlur"
  @keyup.enter.native="handleEnter"
  :formatter="format"
  :lazy-formatter="lazyFormatter"
  :placeholder="placeholder"
  autocomplete="new-password"
  @keypress="restrictInput($event, value)"
  :id="id"
  @paste="handlePaste"
  :type="type"
)
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number, Boolean],
      default: null
    },
    size: {
      type: String,
      default: "md"
    },
    lazyFormatter: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    fieldRequired: {
      type: Boolean,
      default: false
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    keyPressRestrict: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: ""
    },
  },
  methods: {
    restrictInput: function($event, value) {
      if(this.keyPressRestrict == null || this.keyPressRestrict == undefined) return;
      if(this[this.keyPressRestrict] == null || this[this.keyPressRestrict] == undefined) return;
      this[this.keyPressRestrict]($event, value);
    },
    restrictTwoDPlace: function($event, value) {
      value = value.toString();

      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || value.indexOf('.') != -1)) { // 46 is dot
        $event.preventDefault();
      }

      // restrict to 1 decimal places
      var currentValue = value.toString() + $event.key;
      var selectedText = window.getSelection().toString();
      currentValue = currentValue.replace(selectedText, '');

      if(currentValue.indexOf(".") != -1) {
        if(currentValue.split('.')[1].length > 2) {
          $event.preventDefault();
        }
        if(currentValue == '.') {
          $event.preventDefault();
        }
      }
    },
    restrictOnlyNumber: function($event, value) {
      // value = value.toString();

      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

      // only allow number
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    handleBlur(e) {
      this.$emit("blur", e.srcElement.value);
    },
    handleEnter(e) {
      this.$emit("enter", e);
    },
    handleInput(e) {
      this.$emit("input", e);
    },
    handlePaste(event) {
      // Check if this input is meant for numbers/integers
      if (this.type === 'number') {
        event.preventDefault();
      }
    },
    format(value, event) {
      // this.$emit("format", value, event);
      if(!this.fieldRequired)
        return value;

      if(event.target == null)
        return value;

      if(value == null || value == "")
        return 0;

      return value;
    }
  }
};
</script>
